'use client';

import { Button } from '@repo/ui';
import { Loader2, Scissors } from 'lucide-react';
import type { JSX } from 'react';

interface ICropBatchBarProps {
  selectedCount: number;
  pendingSelected: number;
  isCropping: boolean;
  onCropSelected: () => void;
  onSelectAll: () => void;
  onDeselectAll: () => void;
}

export function CropBatchBar({
  selectedCount,
  pendingSelected,
  isCropping,
  onCropSelected,
  onSelectAll,
  onDeselectAll,
}: ICropBatchBarProps): JSX.Element {
  return (
    <div className="flex items-center justify-between border-b pb-4">
      <div className="flex items-center gap-3">
        <span className="text-sm text-muted-foreground">{selectedCount} selected</span>
        <Button variant="ghost" size="sm" onClick={onSelectAll}>
          Select All
        </Button>
        <Button variant="ghost" size="sm" onClick={onDeselectAll} disabled={selectedCount === 0}>
          Clear
        </Button>
      </div>
      <div className="flex items-center gap-2">
        {pendingSelected > 0 && (
          <Button onClick={onCropSelected} disabled={isCropping} size="sm" className="gap-1.5">
            {isCropping ? (
              <Loader2 className="h-4 w-4 animate-spin" />
            ) : (
              <Scissors className="h-4 w-4" />
            )}
            Crop ({pendingSelected})
          </Button>
        )}
      </div>
    </div>
  );
}
